/**
 * AIW1-F4 (the 117th) - how a listing proposal greets its owner. His rule, 2026-10-04: a person's name when we have one,
 * the BUSINESS NAME when that is all we have. Before, "Test Owner LLC" with the default "Mr." printed "Dear Mr. LLC,"
 * (the honorific plus the name's last word) - and 2,406 of 7,782 record owners (31%) look like companies.
 */

/** A word that marks an owner as a company or a trust, anywhere in the name. "L.L.C." and "L.P." count. */
const COMPANY_WORD =
  /\b(?:llc|l\.l\.c\.?|inc\.?|incorporated|corp\.?|corporation|company|co\.|lp|l\.p\.?|llp|ltd\.?|limited|trust|holdings|partners|partnership|properties|investments|ventures|enterprises|associates|group|realty|fund|foundation|church|bank|industries|development|association|authority|district|capital|management)(?=$|[\s,.;)])/i;
/** The review (the 117th): a public owner ("City of Riverside"), and a bare "Co" ENDING the name ("Smith Construction Co"). */
const PUBLIC_OWNER = /^(?:the\s+)?(?:city|county|state|town|village)\s+of\s/i;
const TRAILING_CO = /\sco$/i;

export const looksLikeCompany = (ownerName: string): boolean => {
  const name = ownerName.trim();
  return COMPANY_WORD.test(name) || PUBLIC_OWNER.test(name) || TRAILING_CO.test(name);
};

/**
 * The greeting's two parts, as the builder joins them ("Dear " + honorific + name + ","; a blank honorific is dropped).
 * - a salutation name he typed: the person, with the honorific he picked;
 * - none, and the owner is a company: the business name alone ("Dear Test Owner LLC,");
 * - none, and the owner is a person: the honorific and the last word of the name, as his letters do.
 */
export const greetingFor = (ownerName: string, honorific: string, salutationName: string): { honorific: string; salutationName: string } => {
  const typed = salutationName.trim();
  if (typed) return { honorific: honorific || 'Mr.', salutationName: typed };
  const owner = ownerName.trim();
  if (looksLikeCompany(owner)) return { honorific: '', salutationName: owner };
  return { honorific: honorific || 'Mr.', salutationName: owner.split(' ').slice(-1)[0] };
};
